var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-form-textarea-input',{attrs:{"title":"Escriba la nota","label":"Escriba la nota","error-message":"Debe escribir la nota","has-error":_vm.$v.note.note.$error,"required":_vm.required},model:{value:(_vm.note.note),callback:function ($$v) {_vm.$set(_vm.note, "note", $$v)},expression:"note.note"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }